import React from "react";

// Per-matchup swimmer-scoring breakdown, rendered as an overlay modal.
// Shared between the admin Game tab and the public League → Matches tab.

const MatchupDetailsModal = ({ state, loading, error, onClose }) => {
  const overlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(2, 8, 23, 0.78)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    padding: "1.5rem",
  };
  const dialog = {
    background: "#0c1a36",
    border: "1px solid #2e4a78",
    borderRadius: "8px",
    padding: "1.25rem",
    maxWidth: "880px",
    width: "100%",
    maxHeight: "85vh",
    overflowY: "auto",
    color: "#cddcf8",
    boxShadow: "0 18px 40px rgba(0,0,0,0.55)",
  };
  const headerRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "0.85rem",
    gap: "0.75rem",
  };
  const closeBtn = {
    background: "transparent",
    border: "1px solid #3d5680",
    color: "#a8fff0",
    borderRadius: "4px",
    padding: "0.25rem 0.6rem",
    fontSize: "0.78rem",
    fontWeight: 600,
    cursor: "pointer",
  };
  const coachCard = {
    border: "1px solid #2e4a78",
    borderRadius: "6px",
    padding: "0.7rem 0.85rem",
    background: "#0a162d",
  };
  const coachTitle = (isWinner) => ({
    fontSize: "0.95rem",
    fontWeight: 700,
    color: isWinner ? "#a8fff0" : "#cddcf8",
    marginBottom: "0.15rem",
  });
  const swimmerRow = {
    borderTop: "1px solid #1e3257",
    padding: "0.45rem 0",
    fontSize: "0.78rem",
  };
  const eventLine = {
    display: "grid",
    gridTemplateColumns: "1.6fr 0.7fr 0.6fr 0.6fr 0.55fr",
    gap: "0.4rem",
    color: "#9fb7e3",
    fontSize: "0.72rem",
    padding: "0.1rem 0",
  };
  const eventHeader = {
    ...eventLine,
    color: "#6884b7",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  };
  const fmtTime = (t) => (t == null ? "—" : String(t));
  const fmtNum = (n) => Number(n || 0).toFixed(2);

  return (
    <div style={overlay} onClick={onClose}>
      <div style={dialog} onClick={(e) => e.stopPropagation()}>
        <div style={headerRow}>
          <div>
            <div
              style={{
                fontSize: "0.72rem",
                color: "#6884b7",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              Week {state.week} matchup
            </div>
            <div style={{ fontSize: "1.05rem", fontWeight: 700, color: "#cddcf8" }}>
              {state.meet_label || "Loading…"}
            </div>
          </div>
          <button type="button" style={closeBtn} onClick={onClose}>
            Close
          </button>
        </div>

        {loading && <p style={{ color: "#9fb7e3" }}>Loading swimmer breakdown…</p>}
        {error && !loading && <p style={{ color: "#ff93b0" }}>Error: {error}</p>}

        {!loading && !error && Array.isArray(state.matchup) && (
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.85rem" }}>
            {state.matchup.map((side) => (
              <div key={side.coach} style={coachCard}>
                <div style={coachTitle(side.is_winner)}>
                  {side.coach}
                  {side.is_winner && (
                    <span
                      style={{
                        fontSize: "0.65rem",
                        color: "#a8fff0",
                        marginLeft: "0.45rem",
                      }}
                    >
                      WINNER
                    </span>
                  )}
                </div>
                <div
                  style={{
                    color: "#6884b7",
                    fontSize: "0.78rem",
                    marginBottom: "0.45rem",
                  }}
                >
                  Total:{" "}
                  <span style={{ color: "#cddcf8", fontWeight: 600 }}>
                    {fmtNum(side.total_points)}
                  </span>
                </div>
                {side.swimmers.length === 0 ? (
                  <div
                    style={{
                      color: "#6884b7",
                      fontSize: "0.78rem",
                      fontStyle: "italic",
                    }}
                  >
                    No swimmers scored points.
                  </div>
                ) : (
                  side.swimmers.map((sw) => (
                    <div key={sw.name} style={swimmerRow}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "0.2rem",
                        }}
                      >
                        <strong style={{ color: "#cddcf8" }}>{sw.name}</strong>
                        <span style={{ color: "#a8fff0", fontWeight: 600 }}>
                          {fmtNum(sw.swimmer_total)}
                        </span>
                      </div>
                      <div style={eventHeader}>
                        <span>Event</span>
                        <span>Time</span>
                        <span>Drop pts</span>
                        <span>Place pts</span>
                        <span>Total</span>
                      </div>
                      {sw.events.map((ev, i) => (
                        <div key={i} style={eventLine}>
                          <span>{ev.event || "—"}</span>
                          <span>{fmtTime(ev.final_time)}</span>
                          <span>{fmtNum(ev.time_drop_points)}</span>
                          <span>{fmtNum(ev.place_points)}</span>
                          <span style={{ color: "#cddcf8" }}>{fmtNum(ev.fantasy_points)}</span>
                        </div>
                      ))}
                    </div>
                  ))
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MatchupDetailsModal;
